export default [
  //North
  {
    name: 'north',
    type: 'gltfModel',
    path: 'models/Roazhon/North/north.glb',
  },
  {
    name: 'structureTexture',
    type: 'texture',
    path: 'models/Roazhon/North/north-structure.jpg',
  },
  {
    name: 'roofTexture',
    type: 'texture',
    path: 'models/Roazhon/North/north-roof.jpg',
  },
  {
    name: 'pillarTexture',
    type: 'texture',
    path: 'models/Roazhon/North/north-pillar.jpg',
  },
  {
    name: 'stairsTexture',
    type: 'texture',
    path: 'models/Roazhon/North/north-stairs.jpg',
  },
  {
    name: 'detailTexture',
    type: 'texture',
    path: 'models/Roazhon/North/north-detail.jpg',
  },
  {
    name: 'chairTexture',
    type: 'texture',
    path: 'models/Roazhon/North/north-chair.jpg',
  },

  {
    name: 'drapeauTexture',
    type: 'texture',
    path: 'models/Roazhon/North/breton.png',
  },

  {
    name: 'hermineTexture',
    type: 'texture',
    path: 'models/Roazhon/North/hermine.png',
  },
  {
    name: 'srfcTexture',
    type: 'texture',
    path: 'models/Roazhon/North/drapeau.png',
  },
  {
    name: 'superuTexture',
    type: 'texture',
    path: 'models/Roazhon/North/superu.png',
  },
  {
    name: 'bannerTexture',
    type: 'texture',
    path: 'models/Roazhon/North/banner.png',
  },

  //South
  {
    name: 'south',
    type: 'gltfModel',
    path: 'models/Roazhon/South/south.glb',
  },
  {
    name: 'southTexture',
    type: 'texture',
    path: 'models/Roazhon/South/south.jpg',
  },
  //West
  {
    name: 'west',
    type: 'gltfModel',
    path: 'models/Roazhon/West/west.glb',
  },
  {
    name: 'westTexture',
    type: 'texture',
    path: 'models/Roazhon/West/west-baked.jpg',
  },
  {
    name: 'tvTexture',
    type: 'texture',
    path: 'models/Roazhon/West/tvscreen.png',
  },
  {
    name: 'logoTexture',
    type: 'texture',
    path: 'models/Roazhon/West/logo.png',
  },
  {
    name: 'rennesMetropole',
    type: 'texture',
    path: 'models/Roazhon/West/rennes-metropole.png',
  },
  //East
  {
    name: 'east',
    type: 'gltfModel',
    path: 'models/Roazhon/East/east-merged.glb',
  },
  {
    name: 'eastTexture',
    type: 'texture',
    path: 'models/Roazhon/East/east.jpg',
  },
  //field
  {
    name: 'field',
    type: 'gltfModel',
    path: 'models/Roazhon/Field/field.glb',
  },
  {
    name: 'fieldTexture',
    type: 'texture',
    path: 'models/Roazhon/Field/field.jpg',
  },
  {
    name: 'logoField',
    type: 'texture',
    path: 'models/Roazhon/Field/logo.png',
  },
  {
    name: 'delarte',
    type: 'texture',
    path: 'models/Roazhon/Field/delarte.png',
  },
  {
    name: 'ouestFrance',
    type: 'texture',
    path: 'models/Roazhon/Field/ouestFrance.png',
  },
  {
    name: 'samsic',
    type: 'texture',
    path: 'models/Roazhon/Field/samsic.png',
  },
  {
    name: 'launay',
    type: 'texture',
    path: 'models/Roazhon/Field/launay.png',
  },
  {
    name: 'rennes',
    type: 'texture',
    path: 'models/Roazhon/West/rennes-metropole.png',
  },
  //Outside
  {
    name: 'outside',
    type: 'gltfModel',
    path: 'models/Roazhon/outside.glb',
  },
  {
    name: 'outsideTexture',
    type: 'texture',
    path: 'models/Roazhon/outside.jpg',
  },

  //cloud
  {
    name: 'cloud',
    type: 'gltfModel',
    path: 'models/Roazhon/cloud.glb',
  },
]
